import ApiClient from "../helpers/ApiClient";

const baseGestaoEndpoint = () => `/gestao/`;

const listEmpresas = () =>
  ApiClient.apiClientDef.get(`${baseGestaoEndpoint()}empresas`);

const GestaoApiClient = { listEmpresas };
export default GestaoApiClient;
